'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * number of (non iframe) page views per session before login/registration auto prompt
 */
var VISITS_PER_SESSION_LOGIN_PROMPT = exports.VISITS_PER_SESSION_LOGIN_PROMPT = 3;

/**
 * length of time before local storage values "expire" as session values
 * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
 */
var PSEUDO_SESSION_EXPIRES_AT = exports.PSEUDO_SESSION_EXPIRES_AT = 14400000;

var KEY_STORAGE = exports.KEY_STORAGE = 'visitCount';
var KEY_PSEUDO_SESSION_STORAGE = exports.KEY_PSEUDO_SESSION_STORAGE = 'pseudoSessionVisitCount';
var KEY_PRE_REGISTRATION_PAGE_VISIT = exports.KEY_PRE_REGISTRATION_PAGE_VISIT = '_dibsPreRegistrationPageVisit';
var TYPE_PRE_REGISTRATION_PAGE_VISIT = exports.TYPE_PRE_REGISTRATION_PAGE_VISIT = 'PRE_REGISTRATION_PAGE_VISIT';
var CAP_PRE_REGISTRATION_PAGE_VISIT = exports.CAP_PRE_REGISTRATION_PAGE_VISIT = 100;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-visit-tracking/dist/visitCountConstants.js
// module id = ./node_modules/dibs-visit-tracking/dist/visitCountConstants.js
// module chunks = 4